module.exports = __webpack_public_path__ + "img/PCT01.ccb6eb62.svg";